<script setup lang="ts">
import { toRefs, watch } from "vue";

import { useGetSectionAppliancesQuery } from "@/composables/kili/sections/queries/use-get-section-appliances-query";
import { toastKiliError } from "@/data/api/kili/common/toast-kili-error";
import { EApplianceType, ESectionRoomType } from "@/data/api/kili/sections/sections.type";
import { useTypedIntl } from "@/locales/typed-intl";
import { getEnumItemTranslationKey } from "@/utils/translation-utils";

import SimpleList from "@/components/ui/list/simple-list.vue";

interface IProps {
  siteId: number;
  sectionId: number;
}

const props = defineProps<IProps>();
const { siteId, sectionId } = toRefs(props);

const { rawT } = useTypedIntl();

const { data: appliances, error: appliancesError } = useGetSectionAppliancesQuery(siteId, sectionId);

watch(appliancesError, (error) => {
  toastKiliError(error);
});
</script>

<template>
  <SimpleList :items="appliances">
    <template #item="{ item }">
      <div class="flex justify-between">
        <div class="flex flex-col gap-1">
          <span class="font-semibold">
            {{ rawT(getEnumItemTranslationKey(ESectionRoomType, "global", item.data.roomType)) }}
          </span>
          <span>
            {{
              rawT(getEnumItemTranslationKey(EApplianceType, "global.applianceType", item.data.applianceElectricalType))
            }}
          </span>
        </div>
      </div>
    </template>
  </SimpleList>
</template>
